export default __webpack_public_path__ + "static/media/photo--lg--pam1.9a98a904.jpg";